module.exports = __webpack_public_path__ + "images/homepage-verified-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./_common/images/homepage-verified-icon.svg
// module id = 158
// module chunks = 1